export default function Temp({ temp, high, low }) {
  return (
    <div className="Container">
      <div className="temp-stack">
        <div className="temp-high">
          <span className="chevron chevron-up">▲</span>
          <span className="temp-value-small">{high}</span>
        </div>
        <div className="Temp">{temp}</div>
        <div className="temp-low">
          <span className="chevron chevron-down">▼</span>
          <span className="temp-value-small">{low}</span>
        </div>
      </div>
    </div>
  );
}
